// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'
// eslint-disable-next-line import/no-unresolved
import PinchZoom from 'https://cdn.skypack.dev/pinch-zoom-js@2.3.4'

if (!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class ProductGallery extends window.BAO.CustomElement() {
      constructor () {
        super()

        this.els.image?.elements.forEach(image =>
          this.initialisePinchZoom(image),
        )

        if (this.els.slide.elements.length < 2) return

        this.controlPrevEl = this.querySelector(
          '[data-el="product-gallery.controlprevious"]',
        )
        this.controlNextEl = this.querySelector(
          '[data-el="product-gallery.controlnext"]',
        )

        this.carousel = this.initialiseCarousel()

        this.controlPrevEl?.addEventListener(
          'click',
          this.onNavClick.bind(this),
        )
        this.controlNextEl?.addEventListener(
          'click',
          this.onNavClick.bind(this),
        )
      }

      initialiseCarousel () {
        return new KeenSlider(this.els.slides.element, {
          duration: 1000,
          mode: 'snap',
          slidesPerView: 1,
          slides: '.car-Carousel_Slide',
          move: instance => {
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.details().relativeSlide,
              )
            })
          },
          created: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.addEventListener('click', () => {
                instance.moveToSlide(dot.dataset.slide)
              })
            })
          },
          slideChanged: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.setAttribute(
                'aria-current',
                parseInt(dot.dataset.slide) === instance.details().relativeSlide,
              )
            })

            const maxClicks =
              instance.details().size - instance.details().slidesPerView

            if (this.controlPrevEl) {
              instance.details().relativeSlide === 0
                ? (this.controlPrevEl.disabled = true)
                : (this.controlPrevEl.disabled = false)
            }

            if (this.controlNextEl) {
              instance.details().relativeSlide >= maxClicks
                ? (this.controlNextEl.disabled = true)
                : (this.controlNextEl.disabled = false)
            }
          },
        })
      }

      onNavClick (event) {
        if (event.currentTarget.dataset.direction === 'previous') {
          this.carousel.prev()
        } else {
          this.carousel.next()
        }
      }

      initialisePinchZoom (image) {
        // eslint-disable-next-line no-new
        new PinchZoom(image.querySelector('.rsp-Image_Image'), {
          draggableUnzoomed: false,
          minZoom: 0.8,
        })
      }
    },
  )
}
